import { ICreditPlanBlockProps } from '@/components/blocks/CreditPlan/CreditPlanBlock';
import { CreditPlanJurisdiction } from '@/components/ui/CreditPlan/util/constants';
import type { LicenseData } from '@/components/ui/SearchModals/utils/licenses';
import { createContext } from 'react';
import { CreditPlanPanelType } from './CreditPlanProvider';
import { CreditPlanResponseModel } from '@/@types/client-api';

export type CreateCreditPlanOptions = {
  content?: ICreditPlanBlockProps;
  practiceAreaModalCooldown?: number;
  promptForPracticeAreas?: boolean;
  sparseLicense?: LicenseData;
};

export interface ICreditPlanContext {
  /** open multi-plan side panel */
  openPanel(jurisdiction?: null, content?: ICreditPlanBlockProps): void;
  /** open single plan (generated/generating) side panel */
  openPanel(jurisdiction: string, content?: ICreditPlanBlockProps): void;
  openPanel(
    jurisdiction: string,
    content?: ICreditPlanBlockProps,
    previousType?: CreditPlanPanelType
  ): void;
  closePanel: () => void;
  handlePanelBackButton?: () => void;
  createCreditPlan: (
    jurisdiction: CreditPlanJurisdiction,
    options?: CreateCreditPlanOptions
  ) => void;
  jurisdictions: CreditPlanJurisdiction[] | undefined;
  isLoading: boolean;
  creditPlans: CreditPlanResponseModel[];
  isPanelOpen: boolean;
}

export const creditPlanContext = createContext<ICreditPlanContext>(
  null as unknown as ICreditPlanContext
);
